import { useTranslation } from 'react-i18next';

import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

import { ListIcon } from './ListIcon';

/** Global search result of entity type `item` (meta: listId, listName, icon, number). */
export function ItemSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('lists');
  const meta = result.meta ?? {};
  const snippet = highlights?.snippet ?? result.snippet;
  return (
    <>
      <span className="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-lg border bg-background text-brand-text shadow-xs">
        <ListIcon name={meta.icon} className="size-[1.125rem]" />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="truncate text-[0.9375rem] font-medium text-foreground">
          {highlights?.title ?? result.title}
        </span>
        <span className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <span>{t('search.item')}</span>
          {meta.listName && <span>{meta.listName}</span>}
          {meta.number && <span>№ {meta.number}</span>}
        </span>
        {snippet && <span className="line-clamp-2 text-sm text-muted-foreground">{snippet}</span>}
      </span>
    </>
  );
}
